import { loadedEnvelopeId } from './esign.state';

export function getLoadedEnvelopeId(): number | null {
  return loadedEnvelopeId.value;
}
